import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import UserBan from 'admin-moderator/containers/UserBan';
import ChatRoomFinishButton from 'chats/ChatRoomFinishButton';
import SocialLinks from 'admin-moderator/components/SocialLinks';
import Avatar from 'components/Avatar';

import Close from 'icons/Close';

import Header from './Header';
import CloseButton from './CloseButton';
import Username from './Username';

class ChatRoomOpenHeader extends React.PureComponent {
  render() {
    return (
      <Header>
        <div style={{ paddingRight: '9px' }}>
          <Link to={`/users/${this.props.userId}`} style={{ textDecoration: 'none' }}>
            <Avatar
              size="40px"
              name={this.props.fullname}
              url={this.props.avatarUrl}
              hasBorder
            />
          </Link>
        </div>

        <div style={{ flexGrow: 1 }}>
          <Username to={`/users/${this.props.userId}`}>{this.props.fullname || 'без имени'}</Username>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <SocialLinks socialLinks={this.props.socialLinks} />

            <div>
              <UserBan
                userId={this.props.userId}
                isBanned={this.props.isBanned}
                onBan={this.props.onBan}
              />
            </div>
          </div>

          {this.props.canFinish && (
            <ChatRoomFinishButton id={this.props.id} onFinished={this.props.onChatRoomFinished} />
          )}
        </div>

        <CloseButton type="button" onClick={this.props.onClose} aria-label="Закрыть">
          <Close />
        </CloseButton>
      </Header>
    );
  }
}

ChatRoomOpenHeader.propTypes = {
  id: PropTypes.string,
  canFinish: PropTypes.bool,

  userId: PropTypes.string,
  fullname: PropTypes.string,
  avatarUrl: PropTypes.string,
  isBanned: PropTypes.bool,
  socialLinks: PropTypes.arrayOf(PropTypes.shape({
    provider: PropTypes.oneOf(['vkontakte', 'odnoklassniki', 'facebook', 'twitter', 'instagram', 'google']),
    socialLink: PropTypes.string,
  })),

  onClose: PropTypes.func,
  onChatRoomFinished: PropTypes.func,
  onBan: PropTypes.func,
};

ChatRoomOpenHeader.defaultProps = {
  id: '',
  canFinish: false,

  userId: '',
  fullname: '',
  avatarUrl: '',
  isBanned: false,
  socialLinks: [],

  onClose: () => {},
  onChatRoomFinished: () => {},
  onBan: () => {},
};

export default ChatRoomOpenHeader;
